
export const PRIMARY_COLOR = "#c0311a"
export const SECONDARY_COLOR = "#79232c"
export const TERTIARY_COLOR = "#e9322b"
export const WARNING_COLOR = "#FFC107"
export const DANGER_COLOR = "#ed1c23"
export const SUCCESS_COLOR = "#4caf50"
export const INFO_COLOR = "#2196f3"
export const LIGHT_PURPLE_COLOR = "#e6d1f2";
